import React from 'react'
import './Progressbar.css'

export default function Progressbar() {
    return (
        <div className='processing' ></div>
    )
}